
// sex : A = 공통 , M = 남자, F=여자
// condType 
// : bw(between) = min ~ max
// : lt = <
// : le = <=
// : gt = >
// : ge = >=
// : null = 없음


//키에 대한 체중의 적정도 평가
const BODY_ITEMS = [
,{ key: 'height', label: '키', unit :'cm', min : null, max: null, refTxt:'' , sex:'A' , condType: null , valueType: 'number'}  
,{ key: 'bdwgh', label: '체중', unit :'Kg', min : null, max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
,{ key: 'stdBdwgh', label: '표준체중', unit: 'kg', min : null, max: null, refTxt: '', sex:'A' , condType: null, valueType: 'number'}
,{ key: 'bmi', label: '체질량지수(BMI)', unit :'kg/m2', min : 18.5, max: 23, refTxt:'18.5 ~ 23', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'wastln', label: '허리둘레', unit :'cm', min : null, max: 90, refTxt:'~90', sex:'M' , condType: 'le', valueType: 'number'}  
,{ key: 'wastln', label: '허리둘레', unit :'cm', min : null, max: 85, refTxt:'~85', sex:'F' , condType: 'le', valueType: 'number'}  
,{ key: 'bfp', label: '체지방률', unit :'%', min : 11, max: 20, refTxt:'11 ~ 20', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'bfp', label: '체지방률', unit :'%', min : 18, max: 28, refTxt:'18 ~ 28', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'whr', label: '복부지방률', unit :'', min : 0.75, max: 0.85, refTxt:'0.75 ~ 0.85', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'whr', label: '복부지방률', unit :'', min : 0.7, max:0.8, refTxt:'0.7 ~ 0.8', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'lbm', label: '체지방량', unit: 'kg', min : null, max: null, refTxt: '', sex:'A' , condType: null, valueType: 'number'}
,{ key: 'smm', label: '근육량', unit :'kg', min : null, max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
,{ key: 'hipcrc', label: '엉덩이둘레', unit :'cm', min : null , max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
]

//혈압
const BP_ITEMS = [
,{ key: 'brssrTop', label: '수축기 혈압', unit :'mmHg', min : 90, max: 140, refTxt:'90 ~ 140', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'brssrLwet', label: '이완기 혈압(최저혈압)', unit :'mmHg', min : 60, max: 90, refTxt:'60 ~ 90', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'puls', label: '맥박', unit :'rate', min : 60, max: 100, refTxt:'60 ~ 100', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//심장 기본검사
const DEF_HEART_ITEMS = [
{ key: 'ecg', label: '심전도', unit: '', min : null , max: null, refTxt: '', sex:'A' , condType: null, valueType: 'string'}
]

// 심장/혈관 관련 혈액 검사
const HEART_ITEMS = [
{ key: 'crp', label: '고감도 C 반응성 단백질(hs-CRP)', unit :'mg/dl', min : 0, max: 0.5, refTxt:'0 ~ 0.5', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//혈액 지질 검사
const LIPID_ITEMS = [
,{ key: 'tchol', label: '총콜레스테롤', unit :'mg/dl', min : null, max: 200, refTxt:'<200', sex:'A' , condType: 'lt', valueType: 'number'}  
,{ key: 'ldl', label: '저밀도 콜레스테롤(LDL-C)', unit :'mg/dl', min : null, max: 100, refTxt:'<100', sex:'A' , condType: 'lt', valueType: 'number'}  
,{ key: 'hdl', label: '고밀도 콜레스테롤(HDL-C)', unit :'mg/dl', min : 40, max: null, refTxt:'>40', sex:'A' , condType: 'gt', valueType: 'number'}  
,{ key: 'tg', label: '중성지방', unit :'mg/dl', min : 40, max: 200, refTxt:'40~200', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//당뇨병 관련 검사
const DIABETES_ITEMS = [
,{ key: 'fbg', label: '공복혈당', unit :'mg/dl', min : 70, max: 99, refTxt:'70 ~ 99', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'hba1c', label: '당화혈색소', unit :'%', min : 4.4, max: 6.0, refTxt:'4.4 ~ 6.0', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//기타 대사 장애검사
const METABOLIC_ITEMS = [
,{ key: 'ua', label: '요산', unit :'mg/dl', min : 3.4, max: 7, refTxt:'3.4 ~ 7', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'ua', label: '요산', unit :'mg/dl', min : 2.4, max: 5.7, refTxt:'2.4 ~ 5.7', sex:'F' , condType: 'bw', valueType: 'number'}  
]

//일반혈액검사
const CBC_ITEMS = [
,{ key: 'rbcCo', label: '적혈구수', unit :'10^12/L', min : 4.5, max:5.5, refTxt:'4.5 ~ 5.5', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'rbcCo', label: '적혈구수', unit :'10^12/L', min : 4.0, max:5.0, refTxt:'4.0 ~ 5.0', sex:'F' , condType: 'bw', valueType: 'number'}
,{ key: 'wbcCo', label: '백혈구수', unit :'10^9/L', min : 4.0, max: 10.0, refTxt:'4.0 ~ 10.0', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'neu', label: '호중구', unit :'%', min : 50, max: 75, refTxt:'50 ~ 75', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'baso', label: '호염구', unit :'%', min : 0, max: 2, refTxt:'0 ~ 2', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'eos', label: '호산구', unit :'%', min : 0, max: 5, refTxt:'0 ~ 5', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'lym', label: '림프구', unit :'%', min : 20, max: 44, refTxt:'20 ~ 44', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'mono', label: '단핵구(monocytes)', unit :'%', min : 2, max: 9, refTxt:'2 ~ 9', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'pltCo', label: '혈소판수', unit :'10^9/L', min : 150, max: 450, refTxt:'150 ~ 450', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'plv', label: '혈소판용적율', unit :'%', min : 0.15, max:0.4, refTxt:'0.15 ~ 0.4', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'mvp', label: '평균 혈소판 용적(MPV)', unit :'fl', min : 7.91, max: 11.79, refTxt:'7.91 ~ 11.79', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'pdw', label: '혈소판 분포계수', unit :'fl', min : 9.13, max: 19.41, refTxt:'9.13 ~ 19.41', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'anc', label: 'ANC', unit :'10^9/L', min : null, max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
]


//빈혈검사 및 혈액형 검사
const ANEMIA_ITEMS = [
,{ key: 'hgb', label: '혈색소', unit :'g/dl', min : 13, max: 18, refTxt:'13 ~ 18', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'hgb', label: '혈색소', unit :'g/dl', min : 12, max: 16, refTxt:'12 ~ 16', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'hct', label: '적혈구 용적율', unit :'%', min : 40.0, max:54.0, refTxt:'40.0 ~ 54.0', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'hct', label: '적혈구 용적율', unit :'%', min : 34.0, max:49.0, refTxt:'34.0 ~ 49.0', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'rdw', label: '적혈구분포계수', unit :'%', min : 11.5, max: 14.5, refTxt:'11.5 ~ 14.5', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'mcv', label: '평균적혈구용적', unit :'fl', min : 80, max: 99, refTxt:'80 ~ 99', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'mcv', label: '평균적혈구용적', unit :'fl', min : 79, max: 95, refTxt:'79 ~ 95', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'mch', label: '평균적혈구혈색소량', unit :'pg', min : 27, max: 33, refTxt:'27 ~ 33', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'mch', label: '평균적혈구혈색소량', unit :'pg', min : 26, max: 32, refTxt:'26 ~ 32', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'mchc', label: '평균 혈구내 헤모글로빈농도', unit :'%', min : 32, max: 36, refTxt:'32 ~ 36', sex:'A' , condType: 'bw', valueType: 'number'}  
// ,{ key: 'seasn', label: '철', unit :'mcg/dl', min : 33, max: 193, refTxt: '33 ~ 193', sex:'F', condType: 'bw', valueType: 'number'}  // 항목 삭제 요청_261029
// ,{ key: 'tibc', label: '철결합능', unit :'mcg/dl', min : 228, max: 428, refTxt:'228 ~ 428', sex:'F' , condType: 'bw', valueType: 'number'}  // 항목 삭제 요청_261029
// ,{ key: 'frtn', label: '페리틴', unit :'ng/mL', min : 13, max: 150, refTxt:'13 ~ 150', sex:'F' , condType: 'bw', valueType: 'number'}  // 항목 삭제 요청_261029
]

//간,담도,췌장검사
// - 감,담도췌장 기능 혈액 검사
const LIVER_ITEMS = [
,{ key: 'tprtn', label: '총단백 정량', unit :'g/dl', min : 6.6, max: 8.7, refTxt:'6.6 ~ 8.7', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'alb', label: '알부민', unit :'g/dl', min : 3.5, max: 5.2, refTxt:'3.5 ~ 5.2', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'glb', label: '글로불린', unit :'g/dl', min : 1.5, max: 4.1, refTxt:'1.5 ~ 4.1', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'agr', label: '알부민/글로불린 비율', unit :'', min : 1.2, max: 2.2, refTxt:'1.2 ~ 2.2', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'ast', label: 'AST(SGOT)', unit :'U/L', min : 0, max: 40, refTxt:'0 ~ 40', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'ast', label: 'AST(SGOT)', unit :'U/L', min : 0, max: 32, refTxt:'0 ~ 32', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'alt', label: 'ALT(SGPT)', unit :'U/L', min : 0, max:41, refTxt:'0 ~ 41', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'alt', label: 'ALT(SGPT)', unit :'U/L', min : 0, max: 33, refTxt:'0 ~ 33', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'alp', label: '알칼리 포스파타제', unit :'U/L', min : 40, max: 129, refTxt:'40 ~ 129', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'alp', label: '알칼리 포스파타제', unit :'U/L', min : 35, max: 104, refTxt:'35 ~ 104', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'tbil', label: '총 빌리루빈', unit :'mg/dl', min : 0, max: 1.2, refTxt:'0 ~ 1.2', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'dbil', label: '직접빌리루빈', unit :'mg/dl', min : 0.13, max: 0.47, refTxt:'0.13 ~ 0.47', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'ggt', label: '감마-GTP', unit :'U/L', min : 10, max: 71, refTxt:'10 ~ 71', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'ggt', label: '감마-GTP', unit :'U/L', min : 6, max: 42, refTxt:'6 ~ 42', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'amyl', label: '아밀라제', unit :'U/L', min : 28, max: 100, refTxt:'28 ~ 100', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//간,담도,췌장검사
// - 간염검사
const HEPATITIS_ITEMS = [
,{ key: 'hbsag', label: 'B형간염 S항원', unit :'S/CO', min : null, max:null, refTxt:'Negative(1.0 미만)', sex:'A' , condType: null, valueType: 'string'}  
,{ key: 'hbsab', label: 'B형간염 S항체', unit :'IU/mL', min : null, max:10, refTxt:'10미만', sex:'A' , condType: 'lt', valueType: 'string'}  
,{ key: 'hcvab', label: 'C형간염 항체', unit :'S/CO', min : null, max:null, refTxt:'Negative(1.0 미만)', sex:'A' , condType: null, valueType: 'string'}  
,{ key: 'havab', label: 'A형간염 항체(lgG)', unit :'S/CO', min : null, max:null, refTxt:'Negative(1.0 미만)', sex:'A' , condType: null, valueType: 'string'}  
]

//신장검사
// - 신장기능혈액검사
const KIDNEY_ITEMS = [
,{ key: 'bun', label: '요소질소', unit :'mg/dl', min : 6.0, max: 20.0, refTxt:'6.0 ~ 20.0', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'crtnn', label: '크레아티닌', unit :'mg/dl', min : 0.7, max: 1.2, refTxt:'0.7 ~ 1.2', sex:'M' , condType: 'bw', valueType: 'number'}  
,{ key: 'crtnn', label: '크레아티닌', unit :'mg/dl', min : 0.5, max: 0.9, refTxt:'0.5 ~ 0.9', sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'egfr', label: 'e-GFR', unit :'mL/min/1.73m²', min : null, max: null, refTxt:'-', sex:'A' , condType: null, valueType: 'number'}  
]

//신장검사
// - 전해질검사
const ELECTROLYTE_ITEMS = [
,{ key: 'sodm', label: '나트륨(sodium, Na)', unit :'mEq/L', min : 136, max: 145, refTxt:'136 ~ 145', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'potsm', label: '칼륨(potassium, K)', unit :'mEq/L', min : 3.5, max: 5.1, refTxt:'3.5 ~ 5.1', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'chlor', label: '염소(Cl)', unit :'mEq/L', min : 98, max: 110, refTxt:'98 ~ 110', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'totCa', label: '총 칼슘(Ca)', unit :'mg/dl', min : 8.6, max: 10.2, refTxt:'8.6 ~ 10.2', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'phs', label: '인(P)', unit :'mg/dl', min : 2.5, max: 4.5, refTxt:'2.5 ~ 4.5', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//신장검사
// - 소변검사
const URINALYSIS_ITEMS = [
,{ key: 'relimp', label: '비중', unit :'', min : 1.003, max: 1.030, refTxt:'1.003 ~ 1.030', sex:'A' , condType: 'bw', valueType: 'number'}  
// ,{ key: 'poh', label: '요 산도 검사', unit :'', min : 5.0, max: 7.5, refTxt:'5.0 ~ 7.5', sex:'A' , condType: 'bw', valueType: 'number'}  // 20261016 삭제요청
,{ key: 'uprtn', label: '요단백', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null, valueType: 'string'}  
,{ key: 'uglu', label: '요당', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A'  , condType: null, valueType: 'string'}  
,{ key: 'uket', label: '소변 케톤', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'ubil', label: '빌리루빈', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'uuro', label: '유로빌리노겐', unit :'', min : null, max: null, refTxt:'음성(Trace)', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'unitr', label: '아질산염', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'occbl', label: '요잠혈검사', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null , valueType: 'string'}  
// ,{ key: 'color', label: 'color', unit :'', min : null, max: null, refTxt:'', sex:'M' , condType: null , valueType: 'string'}   // 20261016 삭제요청
,{ key: 'urWbc', label: '소변 백혈구', unit :'', min : null, max: null, refTxt:'음성(Negative)', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'urbc', label: '요침사 적혈구 수', unit :'HPF', min : 0, max:1, refTxt:'0 - 1', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'uwbc', label: '요침사 백혈수구 수', unit :'HPF', min : 0, max:3, refTxt:'0 - 3', sex:'A' , condType: null , valueType: 'string'}  
,{ key: 'urBctera', label: '소변 세균', unit :'', min : null, max: null, refTxt:'', sex:'A' , condType: null , valueType: 'string'}  
// ,{ key: 'sqepc', label: '편평상피세포', unit :'', min : 0, max: 5, refTxt:'0 ~ 5', sex:'M' , condType: 'bw' , valueType: 'string'}  // 20261016 삭제요청
]

//감염 관련 혈액 검사
const INFECTION_ITEMS = [
,{ key: 'vdrl', label: '매독반응 검사(정밀)', unit :'R.U.', min : null, max: 1.0, refTxt:'<1.0', sex:'A'  , condType: 'lt', valueType: 'string'}  
,{ key: 'hivab', label: 'HIV 선별검사', unit :'S/CO', min : null, max: null, refTxt:'Negative(1.0 미만)', sex:'A'  , condType: null, valueType: 'string'}  
]

//종양표지자검사
const TUMOR_MARKER_ITEMS = [
,{ key: 'col6', label: '태아단백호르몬(aFP)', unit :'ng/mL', min : 0, max: 7.0, refTxt:'0 ~ 7.0', sex:'A'  , condType: 'bw', valueType: 'number'}  
,{ key: 'cea', label: '태아성암항원(CEA)', unit :'ng/ml', min : null, max: 3.80, refTxt:'3.80 이하(smoker 5.50 이하)', sex:'A' , condType: 'le', valueType: 'number'}  
,{ key: 'ca199', label: '종양표지자(CA-19-9)', unit :'u/ml', min : 0.00, max: 37.00, refTxt:'0.00 ~ 37.00', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'ca125', label: '종양표지자(CA-125)', unit :'U/ml', min : 0.00, max: 55.0, refTxt:'0.00 ~ 55.0' ,sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'ca153', label: '종양표지자(CA-15-3)', unit :'U/ml', min : 0.00, max: 30.00, refTxt:'0.00 ~ 30.00' ,sex:'F' , condType: 'bw', valueType: 'number'}  
,{ key: 'psa', label: '전립선 특이항원(PSA)', unit :'ng/ml', min : 0, max: 3.5, refTxt:'0 ~ 3.5', sex:'M' , condType: 'bw', valueType: 'number'}  
]

//갑상선 검사
// - 갑상선 기능 혈액 검사
const THYROID_ITEMS = [
,{ key: 't3', label: '트리요도타이로닌T3', unit :'ng/mL', min : 0.6, max: 1.81, refTxt:'0.6 ~ 1.81', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'frt4', label: '유리 싸이록신(free T4)', unit :'ng/dL', min : 0.89, max: 1.76, refTxt:'0.89 ~ 1.76', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'tsh', label: '갑상선자극호르몬(TSH)', unit :'μIU/mL', min : 0.55, max: 4.78, refTxt:'0.55 ~ 4.78', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//골대사 검사
// - 골대사 관련 혈액검사(골표지자)
const BONE_ITEMS = [
,{ key: 'btotCa', label: '총 칼슘(Ca)', unit :'mg/dl', min : 8.6, max: 10.2, refTxt:'8.6 ~ 10.2', sex:'A' , condType: 'bw', valueType: 'number'}
,{ key: 'bPhs', label: '인(P)', unit :'mg/dl', min : 2.5, max: 4.5, refTxt:'2.5 ~ 4.5', sex:'A' , condType: 'bw', valueType: 'number'}  
]
//남성의학 검사
// - 남성의학 혈액검사
const MENS_HEALTH_ITEMS = [
,{ key: 'mPsa', label: '전립선 특이항원(PSA)', unit :'ng/ml', min : 0, max: 3.5, refTxt:'0 ~ 3.5', sex:'M' , condType: 'bw', valueType: 'number'}  
]

//안과 검사
// - 기본 안과 검사
const EYE_ITEMS = [
,{ key: 'vaOs', label: '시력검사(좌)', unit :'', min : null, max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
,{ key: 'vaOd', label: '시력검사(우)', unit :'', min : null, max: null, refTxt:'', sex:'A' , condType: null, valueType: 'number'}  
,{ key: 'bcvaOs', label: '교정시력(좌)', unit :'', min : 0.8, max: null, refTxt:'0.8', sex:'A' , condType: 'ge', valueType: 'number'}  
,{ key: 'bcvaOd', label: '교정시력(우)', unit :'', min : 0.8, max: null, refTxt:'0.8', sex:'A' , condType: 'ge', valueType: 'number'}  
,{ key: 'iopOs', label: '안압 검사(좌)', unit :'mmHg', min : 9, max: 21, refTxt:'9 ~ 21', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'iopOd', label: '안압 검사(우)', unit :'mmHg', min : 9, max: 21, refTxt:'9 ~ 21', sex:'A' , condType: 'bw', valueType: 'number'}  
]

//청력검사
const HEARING_ITEMS = [
,{ key: 'ausHalf', label: '청력(좌)500Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aus1k', label: '청력(좌)1000Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aus2k', label: '청력(좌)2000Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aus4k', label: '청력(좌)4000Hz', unit :'dB', min : 0, max: 50, refTxt:'0 ~ 50', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aus8k', label: '청력(좌)8000Hz', unit :'dB', min : 0, max: 50, refTxt:'0 ~ 50', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'ptaAus', label: '순음청력평균(좌)', unit :'dB', min : null, max: 35 , refTxt:'35', sex:'A' , condType: 'le', valueType: 'number'}  
,{ key: 'audHalf', label: '청력(우)500Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aud1k', label: '청력(우)1000Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aud2k', label: '청력(우)2000Hz', unit :'dB', min : 0, max: 30, refTxt:'0 ~ 30', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aud4k', label: '청력(우)4000Hz', unit :'dB', min : 0, max: 50, refTxt:'0 ~ 50', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'aud8k', label: '청력(우)8000Hz', unit :'dB', min : 0, max: 50, refTxt:'0 ~ 50', sex:'A' , condType: 'bw', valueType: 'number'}  
,{ key: 'ptaAud', label: '순음청력평균(우)', unit :'dB', min : null, max: 35, refTxt:'35', sex:'A', condType: 'le', valueType: 'number'}  
,{ key: 'adgrAus', label: '청력도(좌)', unit :'', min : null, max: null, refTxt:'정상', sex:'A' , condType: null, valueType: 'string'}  
,{ key: 'adgrAud', label: '청력도(우)', unit :'', min : null, max: null, refTxt:'정상', sex:'A' , condType: null, valueType: 'string'}  
]

export {
  BODY_ITEMS,
  BP_ITEMS,
  DEF_HEART_ITEMS,
  HEART_ITEMS,
  LIPID_ITEMS,
  DIABETES_ITEMS,
  METABOLIC_ITEMS,
  CBC_ITEMS,
  ANEMIA_ITEMS,
  LIVER_ITEMS,
  HEPATITIS_ITEMS,
  KIDNEY_ITEMS,
  ELECTROLYTE_ITEMS,
  URINALYSIS_ITEMS,
  INFECTION_ITEMS,
  TUMOR_MARKER_ITEMS,
  THYROID_ITEMS,
  BONE_ITEMS,
  MENS_HEALTH_ITEMS,
  EYE_ITEMS,
  HEARING_ITEMS,
};